import React from "react";
import { Card, CardBody } from "reactstrap";
import PerfectScrollBar from "react-perfect-scrollbar";
import { FaqsDto } from "../../redux/homepage/type";

const Question = ({ faq, index }: { faq: FaqsDto; index: number }) => {
  return (
    <React.Fragment>
      <Card style={{ height: 200 }} className="mt-3">
        <CardBody
          className="overflow-hidden position-relative"
          style={{ fontSize: 12 }}
        >
          <div>
            <i className="bx bx-help-circle widget-box-1-icon text-primary"></i>
          </div>
          <div className="faq-count">
            <h5 className="">{index + 1}.</h5>
          </div>

          <PerfectScrollBar>
            <h6
              className="mt-3 faqText questionText"
              dangerouslySetInnerHTML={{
                __html: faq.Question,
              }}
            ></h6>
            <p
              className="text-muted mt-3 mb-4 faqText answerText py-2"
              dangerouslySetInnerHTML={{
                __html: faq.Answer,
              }}
            ></p>
          </PerfectScrollBar>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default Question;
